import { render } from "./Webmail.vue?vue&type=template&id=5ef21d9a&scoped=true"
import script from "./Webmail.vue?vue&type=script&lang=ts"
export * from "./Webmail.vue?vue&type=script&lang=ts"

import "./Webmail.vue?vue&type=style&index=0&id=5ef21d9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ef21d9a"

export default script